import React from "react";
import { createRoot } from "react-dom/client";

import "./index.scss";
import { App } from "./components/layout";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
